import { render, staticRenderFns } from "./TransferSelection.vue?vue&type=template&id=34f67fa3"
import script from "./TransferSelection.vue?vue&type=script&lang=js"
export * from "./TransferSelection.vue?vue&type=script&lang=js"
import style0 from "./TransferSelection.vue?vue&type=style&index=0&id=34f67fa3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports